import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ContentSection } from 'src/shared/components/organisms/contentSection';
import { EmptyGridCell } from 'src/shared/components/atoms/emptyGridCell';
import { DateHelper } from 'src/shared/helpers/dateHelper';
import dayjs from 'dayjs';
import { Member, MemberTitle } from '../models/member';

type MemberTitleSummaryProps = {
  member: Member;
};

export const MemberTitleSummary = (props: MemberTitleSummaryProps) => {
  const {
    member: { titles },
  } = props;
  const { t } = useTranslation(['member']);
  return (
    <Box sx={{ mt: 2 }}>
      <ContentSection header={t('member:memberDetails.memberTitleSummary')}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell> </TableCell>
                <TableCell>{t('member:memberDetails.memberTitle.title')}</TableCell>
                <TableCell>{t('member:memberDetails.memberTitle.organizationName')}</TableCell>
                <TableCell>{t('member:memberDetails.memberTitle.admdate')}</TableCell>
                <TableCell>{t('member:memberDetails.memberTitle.resdate')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {titles
                .sort((a: MemberTitle, b: MemberTitle) => (a.resdate < b.resdate ? -1 : 1))
                .map((item: MemberTitle) => {
                  const isResigned = item.resdate && dayjs(item.resdate).isBefore(new Date());
                  return (
                    <TableRow
                      key={`${item.title}${item.organizationName}`}
                      sx={{
                        '& .MuiTableCell-root': {
                          color: (thm) => `${isResigned ? thm.palette.text.disabled : thm.palette.text.primary} !important`,
                          textDecoration: isResigned ? 'line-through' : 'none',
                        },
                      }}
                    >
                      <TableCell sx={{ width: '1rem' }}>
                        <Box
                          sx={{
                            width: 10,
                            height: 10,
                            boxSizing: 'border-box',
                            backgroundColor: (thm) => (isResigned ? thm.palette.grey[100] : thm.palette.success.main),
                            border: (thm) => (isResigned ? `2px solid ${thm.palette.grey[500]}` : 'none'),
                            borderRadius: '100%',
                          }}
                        />
                      </TableCell>
                      <TableCell>{item.title || <EmptyGridCell />}</TableCell>
                      <TableCell>{item.organizationName || <EmptyGridCell />}</TableCell>
                      <TableCell>{DateHelper.getDate(item.admdate) || <EmptyGridCell />}</TableCell>
                      <TableCell>{item.resdate ? DateHelper.getDate(item.resdate) : <EmptyGridCell />}</TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </ContentSection>
    </Box>
  );
};
